import Amplify from 'aws-amplify';
import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom';
import awsconfig from './aws-exports';
import Spinner from './components/@vuexy/spinner/Fallback-spinner';
import * as serviceWorker from './serviceWorker';
import './index.scss';
import './@fake-db';

const isLocalhost = Boolean(
  window.location.hostname === "localhost" ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === "[::1]" ||
    // 127.0.0.1/8 is considered localhost for IPv4.
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
);

const [
  localRedirectSignIn,
  productionRedirectSignIn,
] = awsconfig.oauth.redirectSignIn.split(",");

const [
  localRedirectSignOut,
  productionRedirectSignOut,
] = awsconfig.oauth.redirectSignOut.split(",");

const updatedAwsConfig = {
  ...awsconfig,
  oauth: {
    ...awsconfig.oauth,
    redirectSignIn: isLocalhost ? localRedirectSignIn : productionRedirectSignIn,
    redirectSignOut: isLocalhost ? localRedirectSignOut : productionRedirectSignOut,
  }
}

Amplify.configure({
  ...updatedAwsConfig,
  Auth: {
    mandatorySignIn: false,
  },
  Analytics: {
    disabled: true,
  },
});

const LazyApp = lazy(() => window.location.pathname === '/embed-feed' ?
  import('./AppLight') : import('./App'));

// configureDatabase()
ReactDOM.render(<Suspense fallback={<Spinner />}>
    <LazyApp />
  </Suspense>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
